module.exports = __webpack_public_path__ + "img/icon_truck.430d71dd.svg";